import React, { useState, useEffect } from "react";
import Switch from "react-switch";
import Flatpickr from 'react-flatpickr';
import moment from 'moment';

const weeks = [
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thu' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' },
  { label: 'Sunday', value: 'sun' },
];
const parseOpenEnd = (value) => {
  if (!value) return { openTime: '', closeTime: '' };
  if (value === 'closed') return { openTime: '', closeTime: '' };
  const values = value.split('-').map((x) => (x.trim()));
  return {
    openTime: values[0],
    closeTime: values[1],
  }
}

const OpenClosePicker = ({ value, onChange }) => {
  const openingTimes = parseOpenEnd(value || '');
  const [selectedHours, setSelectedHours] = useState(openingTimes);
  const isClosed = value === 'closed';
  // Handle selection of opening hours
  const handleHoursChange = (tp, hours) => {
    const newTimes = {
      ...selectedHours,
      [tp]: moment(hours).format('h:mm A')
    }
    setSelectedHours({
      ...newTimes,
    });

    onChange(`${newTimes.openTime || ''} - ${newTimes.closeTime || ''}`);
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <Flatpickr
          defaultValue={selectedHours.openTime}
          disabled={isClosed}
          placeholder={isClosed ? `closed` : `8:00 AM`}
          className="form-input"
          options={{
            enableTime: true,
            noCalendar: true,
            dateFormat: 'h:i K',
            allowInput: true,
            onChange: e => handleHoursChange('openTime', e[0]),
          }}
        />
      </div>
      {
        !isClosed && <div className="col-md-6">
          <Flatpickr
            defaultValue={selectedHours.closeTime}
            disabled={isClosed}
            // placeholder={isClosed ? `` : `10:00 PM`}        
            className="form-input"
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: 'h:i K',
              allowInput: true,
              onChange: e => handleHoursChange('closeTime', e[0]),
            }}
          />

        </div>
      }

    </div>
  );
};
const FormHours = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  return (
    <React.Fragment>

      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3><i className="sl sl-icon-clock"></i> Opening Hours</h3>
        </div>
        <div className="switcher-content">
          <div className="row margin-bottom-25">
            <div className="col-md-2">
              <label htmlFor="show_hours">
                <h5>{values.show_hours ? 'Hide' : 'Show'} opening hours?</h5>
              </label>
            </div>
            <div className="col-md-10">
              <Switch
                name="show_hours"
                id="show_hours"
                value="1"
                checked={!!values.show_hours && true}
                onChange={(checked) => setFieldValue('show_hours', checked)}
              />
            </div>
          </div>

          {values.show_hours && weeks.map((wk) => (
            <div className="row utf_opening_day utf_js_demo_hours" key={wk.value}>
              <div className="col-md-2">
                <h5>{wk.label} :-</h5>
              </div>
              <div className="col-md-2">
                <Switch
                  value="xxx"
                  checked={!(values[wk.value] === 'closed') && true}
                  onChange={(checked) => setFieldValue(wk.value, checked ? '' : 'closed')}
                />
              </div>
              <div className="col-md-8">
                <OpenClosePicker value={values[wk.value]} onChange={val => setFieldValue(wk.value, val)} />
              </div>

            </div>
          ))}

        </div>
      </div>


    </React.Fragment>
  );
};

export default FormHours;
